import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BASEURL } from '../constants/Common';
import axios from 'axios';

interface AutoLogoutProps {
    onLogoutSuccess?: () => void; // Optional callback for additional actions on logout
}

const AutoLogout: React.FC<AutoLogoutProps> = ({ onLogoutSuccess }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];


        const logout = async () => {
            try {
                // Send a logout request to the API if needed
                await axios.post(`${BASEURL}/logout/`, {}, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                // Clear local storage and state
                localStorage.clear();
                // Notify the user
                toast.info('You have been logged out due to inactivity.');

                // Perform additional actions if needed
                if (onLogoutSuccess) {
                    onLogoutSuccess();
                }

                // Redirect to login or home page
                navigate('/login');
            } catch (error) {
                console.error('Error logging out:', error);
                //toast.error('Failed to log out. Please try again.');
            }
        };

        let logoutTimeout: NodeJS.Timeout;

        const resetTimeout = () => {
            clearTimeout(logoutTimeout);

            logoutTimeout = setTimeout(logout, 30 * 60 * 1000); // 30 minutes
        };

        events.forEach(event => {
            window.addEventListener(event, resetTimeout);
        });

        // Set initial timeout
        resetTimeout();

        return () => {
            clearTimeout(logoutTimeout);

            events.forEach(event => {
                window.removeEventListener(event, resetTimeout);
            });
        };
    }, [navigate, onLogoutSuccess]);

    return null; // This component does not render anything
};

export default AutoLogout;